import React from 'react';
import './IconTest.css';

const IconTest = () => {
  return (
    <div className="icon-test-container">
      <h2>Test des Icônes FontAwesome</h2>
      
      <div className="icon-grid">
        <div className="icon-item">
          <i className="fas fa-home"></i>
          <span>Home</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-user"></i>
          <span>User</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-cog"></i>
          <span>Settings</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-heart"></i>
          <span>Heart</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-star"></i>
          <span>Star</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-leaf"></i>
          <span>Leaf</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-seedling"></i>
          <span>Seedling</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-recycle"></i>
          <span>Recycle</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-solar-panel"></i>
          <span>Solar Panel</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-water"></i>
          <span>Water</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-tree"></i>
          <span>Tree</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-fire"></i>
          <span>Fire</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-industry"></i>
          <span>Industry</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-building"></i>
          <span>Building</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-car"></i>
          <span>Car</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-briefcase"></i>
          <span>Briefcase</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-newspaper"></i>
          <span>Newspaper</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-envelope"></i>
          <span>Envelope</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-phone"></i>
          <span>Phone</span>
        </div>
        
        <div className="icon-item">
          <i className="fas fa-map-marker-alt"></i>
          <span>Location</span>
        </div>
        
        <div className="icon-item">
          <i className="fab fa-facebook"></i>
          <span>Facebook</span>
        </div>
        
        <div className="icon-item">
          <i className="fab fa-twitter"></i>
          <span>Twitter</span>
        </div>
        
        <div className="icon-item">
          <i className="fab fa-linkedin"></i>
          <span>LinkedIn</span>
        </div>
        
        <div className="icon-item">
          <i className="fab fa-instagram"></i>
          <span>Instagram</span>
        </div>
        
        <div className="icon-item">
          <i className="fab fa-youtube"></i>
          <span>YouTube</span>
        </div>
      </div>
      
      <div className="icon-info">
        <h3>Instructions d'utilisation :</h3>
        <p>Pour utiliser FontAwesome dans votre projet, utilisez les classes suivantes :</p>
        <ul>
          <li><strong>Icônes solides :</strong> <code>&lt;i className="fas fa-icon-name"&gt;&lt;/i&gt;</code></li>
          <li><strong>Icônes régulières :</strong> <code>&lt;i className="far fa-icon-name"&gt;&lt;/i&gt;</code></li>
          <li><strong>Icônes de marques :</strong> <code>&lt;i className="fab fa-icon-name"&gt;&lt;/i&gt;</code></li>
          <li><strong>Icônes légères :</strong> <code>&lt;i className="fal fa-icon-name"&gt;&lt;/i&gt;</code></li>
        </ul>
      </div>
    </div>
  );
};

export default IconTest; 